export const engagementSegmentsTags = "/engagement/segments/tags";
